<!--{{ postOffice |json}}-->
<div class=" adressesResponse" *ngIf="isResponseReady && ! isResponseError && ! isEmptyObject( postOffice ) ">

  <ng-container
    *ngIf=" ! isPVPZ( postOffice.typeShirt ) && postOffice.postOfficeLock !='Тимчасово непідконтрольні' && postOffice.postOfficeLock !='Тимчасово окупованих' ">
    <!-- <p class="postOfficeIndex" *ngIf=" ! isPVPZ( postOffice.typeShirt ) && ! isSVPZ( postOffice.typeShirt ) "> -->
      <!-- {{ postOffice.postIndex }}</p> -->
    <!-- <p class="postOfficeIndex" *ngIf=" isPVPZ( postOffice.typeShirt ) || isSVPZ( postOffice.typeShirt ) "> -->
      <!-- {{ postOffice.postCode }}</p> -->
    <p class="postOfficeIndex">
      {{ postOffice.postCode }}</p>

  </ng-container>

  <!--<p class="postOfficeField" *ngIf="postOffice.postOfficeFullName" >{{postOffice.postOfficeFullName}}.</p>-->
  <p class="postOfficeIndex" *ngIf="postOffice.postOfficeType ">{{postOffice.postOfficeType}}</p>
  <p class="postOfficeIndex" *ngIf="postOffice.postOfficeType ">{{postOffice.officeName }}</p>

  <p class="postOfficeField" *ngIf="postOffice.NOTES_UA && isString( postOffice.NOTES_UA ) ">{{postOffice.NOTES_UA}}</p>

  <p class="postOfficeField"
    *ngIf=" ( ! isPVPZ( postOffice.typeShirt ) ) && postOffice.postOfficeAddress && postOffice.postOfficeLock != 'Підконтрольних, але тимчасово не функціонуючих' && postOffice.postOfficeLock !='Тимчасово непідконтрольні' && postOffice.postOfficeLock !='Тимчасово окупованих'">
    <img class="OfficeInfoIcon" src="url(../../assets/pin.svg" />{{postOffice.postOfficeAddress}}.</p>
  <p class="postOfficeField" *ngIf="postOffice.postOfficeLock && postOffice.postOfficeLock != 'Активний запис'">
    {{postOffice.postOfficeLock}}.</p>
  <p class="postOfficeField" *ngIf="( ! isPVPZ( postOffice.typeShirt )) && postOffice.officeFullAddress ">
    {{postOffice.officeFullAddress}}</p>
  <p class="postOfficeField" *ngIf="postOffice.IS_PUDO == 1 && postOffice.ADDRESS_NOTE && postOffice.ADDRESS_NOTE !== '0'">
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" style="margin-right: 5px;" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path fill="#0e2f4b" d="M304 70.1C313.1 61.9 326.9 61.9 336 70.1L568 278.1C577.9 286.9 578.7 302.1 569.8 312C560.9 321.9 545.8 322.7 535.9 313.8L527.9 306.6L527.9 511.9C527.9 547.2 499.2 575.9 463.9 575.9L175.9 575.9C140.6 575.9 111.9 547.2 111.9 511.9L111.9 306.6L103.9 313.8C94 322.6 78.9 321.8 70 312C61.1 302.2 62 287 71.8 278.1L304 70.1zM320 120.2L160 263.7L160 512C160 520.8 167.2 528 176 528L224 528L224 424C224 384.2 256.2 352 296 352L344 352C383.8 352 416 384.2 416 424L416 528L464 528C472.8 528 480 520.8 480 512L480 263.7L320 120.3zM272 528L368 528L368 424C368 410.7 357.3 400 344 400L296 400C282.7 400 272 410.7 272 424L272 528z"/></svg>
    {{ postOffice.ADDRESS_NOTE }}</p>
  <p class="postOfficeField" *ngIf="( isPVPZ( postOffice.typeShirt )) && postOffice.PDAddress ">{{postOffice.PDAddress}}
  </p>
  <p class="" *ngIf="postOffice.Avalible == 0 ">УВАГА! ВПЗ працює автономно. (Надання послуг поштового зв’язку можливо лише у межах території обслуговування ВПЗ)</p>

  <ng-container *ngFor="let period of schedule">
    <div class="group">
      <img class="OfficeInfoIcon" src="url(../../assets/clock.svg" />
      <b><span>{{ period[0] }}</span></b>
      <ng-container *ngFor="let day of period[1]; let i = index">
        <p class="OfficeInfo">
          <span class="space" *ngIf="i >= 0"></span>
          <span>{{ day.DAYOFWEEK_UA }} </span>
          <span>{{ day.TFROM }} - </span>
          <span>{{ day.TTO }}</span>
        </p>
      </ng-container>
      <br>
    </div>
  </ng-container>

  <hr>
  <ng-container *ngIf="postOffice.isNoDistrict == 0 ">

    <ng-container *ngFor="let street of adressObject">
      <div class="streetInfo">
        <p class="streetName">{{street.name}} {{street.type}} <span
            *ngIf="street.haveOldStreetName">({{street.oldStreetName}})</span> </p>
        <p class="houses">{{ street.housesString }} </p>
        <p class="location"> {{ street.location }} </p>
      </div>
    </ng-container>

  </ng-container>


</div>

<!-- Error display 
<div class=" adressesResponse" *ngIf="isResponseError" >
    
  <p class="postOfficeIndex"> Сталася помилка.</p>

  <p class="postOfficeField"  > Перевірте правильність даних. </p>
  
  <hr>

</div> -->